<template>
  <div class="finish">
    <module-banner v-if="!success && !error" :backgound-color="Colors.OffWhite" :image="resultImage">
      <template #headline v-if="textSnippets.ambiguous_headline">
        <base-headline :size="Sizes.Large" :level="1" class="hyphen">{{
          textSnippets.ambiguous_headline
        }}</base-headline>
      </template>
      <template #text>
        <base-text :size="Sizes.Large">{{ textSnippets.ambiguous_text }}</base-text>
        <div class="mb-20 mt-10">
          <base-button
            :to="urls.experts"
            class="inline-flex hover:bg-black hover:text-white transition duration-200 w-full md:w-1/2"
            >{{ textSnippets.experts_button }}</base-button
          >
        </div>
        <base-text :size="Sizes.Large">{{ textSnippets.contact_form_text }}</base-text>
        <div class="mt-10">
          <base-button
            :to="urls.contact_form"
            class="inline-flex hover:bg-black hover:text-white transition duration-200 w-full md:w-1/2"
            >{{ textSnippets.contact_form_button }}</base-button
          >
        </div>
      </template>
      <template #cta>
        <div class="mt-auto"></div>
      </template>
    </module-banner>
    <module-banner v-if="success && !error" :backgound-color="Colors.OffWhite" :image="resultImage">
      <template #headline v-if="textSnippets.submit_success_headline">
        <base-headline :size="Sizes.Large" :level="1" class="hyphen">{{
          textSnippets.submit_success_headline
        }}</base-headline>
      </template>
      <template #text>
        <base-text :size="Sizes.Large">{{ textSnippets.submit_success_text }}</base-text>
      </template>
      <template #cta>
        <div class="mt-auto">
          <base-button
            @click="close"
            class="inline-flex mt-10 hover:bg-black hover:text-white transition duration-200"
            >{{ textSnippets.end_test }}</base-button
          >
        </div>
      </template>
    </module-banner>
  </div>
</template>
<script lang="ts" setup>
import ModuleBanner from '@/components/module/ModuleBanner.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import BaseHeadline from '@/components/base/BaseHeadline.vue'
import BaseText from '@/components/base/BaseText.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import { computed, inject, ref } from 'vue'
import { useMainStore } from '@/store/main'
import { Colors } from '@/types/colors'
import { Sizes } from '@/types/sizes'
import { useRouter } from 'vue-router'

// inject config
const config: any = inject('config')

// inject axios
const axios: any = inject('axios')

// register Store
const store = useMainStore()

// email model
const email = ref('')

/**
 * @return {Language} textSnippets
 */
const textSnippets = computed(() => store.snippets)

/**
 * @return {Urls} urls
 */
const urls = computed(() => store.urls)

/**
 * register router
 */
const router = useRouter()

/**
 * @return {String} resultImage
 */
const resultImage = computed(() => store.images.result_image)

/**
 * @return {Result["resultUuid"]} resultUuid
 */
const resultUuid = computed(() => store.resultUuid)

/**
 * Template vars
 */
const success = ref(false)
const error = ref('')

/**
 * send mail data to backend
 */
const sendMail = async (): Promise<void> => {
  let response
  try {
    response = await axios.post(`${config.baseUrl}/api/v1/questionnaire/${config.testSlug}/submit`, {
      email: email.value,
      resultUuid: resultUuid.value,
    })
  } catch (error) {
    console.error(error)
  }
  if (response) {
    success.value = true
  }
}

/**
 * @description inject the globbal toggleModal function
 */
const toggleModal = inject('toggleModal') as Function
/**
 * @description exported function to close modal in template
 */
const close = () => toggleModal()
</script>
<style scoped>
.hyphen {
  hyphens: auto;
}
</style>
